import Breadcrumbs from '@components/layout/Breadcrumbs';
import ProfileEditor from '@components/portal/ProfileEditor';

/**
 * ProfilePage — User profile editor
 * Route: /profile
 *
 * Sections: Identity (locked for B2C) | Preferences (editable) | Consent (GDPR)
 * Fixed: "Shiping" to "Shipping address" (typo in current app)
 */
export default function ProfilePage() {
  return (
    <div className="max-w-3xl mx-auto px-4 py-8">
      <Breadcrumbs items={[{ label: 'Home', href: '/' }, { label: 'Profile' }]} />
      <h1 className="font-sandvik-headline font-bold text-2xl text-carbon-black mb-6">
        My Profile
      </h1>
      <div className="bg-white border border-n2 p-6">
        <ProfileEditor />
      </div>
    </div>
  );
}
